document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('[data-shipping-estimator]');
  if (!container) return;

  const settingsElement = container.querySelector('[data-shipping-settings]');
  let settings;
  try {
    settings = JSON.parse(settingsElement.textContent);
  } catch (e) {
    console.error('Failed to parse shipping settings', e);
    return;
  }

  const dateElement = container.querySelector('[data-shipping-date]');
  const cutoffElement = container.querySelector('[data-shipping-cutoff]');
  const locationElement = container.querySelector('[data-current-location]');
  const selectElement = container.querySelector('[data-prefecture-select]');
  const selectorContainer = container.querySelector('[data-location-selector]');
  const changeButton = container.querySelector('[data-change-location-trigger]');

  // 都道府県保存キー
  const STORAGE_KEY = 'shipping_estimator_prefecture';

  // 初期化
  let currentPrefecture = localStorage.getItem(STORAGE_KEY) || '東京都';
  selectElement.value = currentPrefecture;
  locationElement.textContent = currentPrefecture;

  // 計算実行
  calculateShippingDate();

  // イベントリスナー
  if (changeButton) {
    changeButton.addEventListener('click', () => {
      selectorContainer.classList.toggle('hidden');
    });
  }

  if (selectElement) {
    selectElement.addEventListener('change', (e) => {
      currentPrefecture = e.target.value;
      localStorage.setItem(STORAGE_KEY, currentPrefecture);
      locationElement.textContent = currentPrefecture;
      selectorContainer.classList.add('hidden');
      calculateShippingDate();
    });
  }

  function calculateShippingDate() {
    const now = new Date();
    
    // 1. 次のカットオフ時間を計算
    const cutoffInfo = getNextCutoffTime(now);
    
    // 2. 発送予定日を計算（カットオフ時間の日から）
    let shippingDate = new Date(cutoffInfo.date);
    shippingDate.setHours(settings.cutoffHour, 0, 0, 0);
    
    // 発送可能な営業日まで進める
    shippingDate = getNextBusinessDay(shippingDate);

    // 3. リードタイムを取得
    const leadTime = getLeadTime(currentPrefecture);

    // 4. お届け日を計算
    let deliveryDate = new Date(shippingDate);
    deliveryDate.setDate(deliveryDate.getDate() + leadTime);

    // お届け日フォーマット
    const days = ['日', '月', '火', '水', '木', '金', '土'];
    const year = deliveryDate.getFullYear();
    const month = (deliveryDate.getMonth() + 1).toString().padStart(2, '0');
    const date = deliveryDate.getDate().toString().padStart(2, '0');
    const day = days[deliveryDate.getDay()];

    dateElement.textContent = `${year}/${month}/${date}（${day}）`;
    
    // カットオフ時間の表示を更新
    cutoffElement.textContent = cutoffInfo.text;
  }

  function getNextCutoffTime(now) {
    const cutoffHour = settings.cutoffHour;
    const currentDate = new Date(now);
    
    // 今日のカットオフ時間
    const todayCutoff = new Date(currentDate);
    todayCutoff.setHours(cutoffHour, 0, 0, 0);
    
    // カットオフ時間を過ぎているかチェック
    if (now >= todayCutoff) {
      // 過ぎている場合は、次の営業日のカットオフ時間を探す
      let nextDate = new Date(currentDate);
      nextDate.setDate(nextDate.getDate() + 1);
      nextDate.setHours(0, 0, 0, 0);
      
      // 次の営業日まで進める
      nextDate = getNextBusinessDay(nextDate);
      nextDate.setHours(cutoffHour, 0, 0, 0);
      
      return formatCutoffText(nextDate, now);
    } else {
      // まだカットオフ時間前なら、今日が営業日かチェック
      const today = new Date(currentDate);
      today.setHours(0, 0, 0, 0);
      
      if (isBusinessDay(today)) {
        // 今日が営業日なら、今日のカットオフ時間を返す
        return formatCutoffText(todayCutoff, now);
      } else {
        // 今日が営業日でない場合は、次の営業日のカットオフ時間を探す
        let nextDate = new Date(currentDate);
        nextDate.setDate(nextDate.getDate() + 1);
        nextDate.setHours(0, 0, 0, 0);
        
        nextDate = getNextBusinessDay(nextDate);
        nextDate.setHours(cutoffHour, 0, 0, 0);
        
        return formatCutoffText(nextDate, now);
      }
    }
  }

  function formatCutoffText(cutoffDate, now) {
    const days = ['日', '月', '火', '水', '木', '金', '土'];
    const today = new Date(now);
    today.setHours(0, 0, 0, 0);
    const cutoff = new Date(cutoffDate);
    cutoff.setHours(0, 0, 0, 0);
    
    const diffDays = Math.floor((cutoff - today) / (1000 * 60 * 60 * 24));
    const cutoffHour = settings.cutoffHour;
    
    if (diffDays === 0) {
      // 今日
      return {
        date: cutoffDate,
        text: `本日${cutoffHour}時00分`
      };
    } else if (diffDays === 1) {
      // 明日
      return {
        date: cutoffDate,
        text: `明日${cutoffHour}時00分`
      };
    } else {
      // 数日後
      const year = cutoffDate.getFullYear();
      const month = (cutoffDate.getMonth() + 1).toString().padStart(2, '0');
      const date = cutoffDate.getDate().toString().padStart(2, '0');
      const day = days[cutoffDate.getDay()];
      return {
        date: cutoffDate,
        text: `${year}年${month}月${date}日（${day}）${cutoffHour}時00分`
      };
    }
  }

  function getNextBusinessDay(startDate) {
    let date = new Date(startDate);
    // 最大30日先までチェック
    for (let i = 0; i < 30; i++) {
      if (isBusinessDay(date)) {
        return date;
      }
      date.setDate(date.getDate() + 1);
    }
    return date;
  }

  function isBusinessDay(date) {
    const dayOfWeek = date.getDay(); // 0: Sun, 1: Mon...
    const dateString = formatDate(date);
    
    // 休業日チェック
    if (settings.holidays && settings.holidays.includes(dateString)) {
      return false;
    }

    // 曜日チェック
    return settings.businessDays[dayOfWeek.toString()];
  }

  function getLeadTime(prefecture) {
    // エリア設定を順番にチェック
    if (settings.areas) {
      for (const area of settings.areas) {
        // 都道府県名が含まれているかチェック（カンマ区切り文字列を想定）
        // 完全一致を確認するために、カンマで囲んでチェックするなどの工夫が必要だが
        // 現状のデータ構造（"北海道,青森県,..."）なら includes で誤検知のリスクは低い
        // （「森」県などは存在しないため）
        if (area.prefectures && area.prefectures.includes(prefecture)) {
          return area.leadTime;
        }
      }
    }
    return settings.defaultLeadTime;
  }

  function formatDate(date) {
    const y = date.getFullYear();
    const m = (date.getMonth() + 1).toString().padStart(2, '0');
    const d = date.getDate().toString().padStart(2, '0');
    return `${y}/${m}/${d}`;
  }
});